/**
 * DATA LAYER (DL): DINOSAUR
 * Comunica con el DinosaurController del backend API.
 */

export const GetThemes = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/GetThemes`);
        if (!response.ok) throw new Error('Error al obtener temas de dinosaurio');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const GetTheme = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/GetTheme/${id}`);
        if (!response.ok) throw new Error('Error al obtener tema');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const SaveTheme = async (data) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/SaveTheme`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error('Error al guardar tema');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const DeleteTheme = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/DeleteTheme/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) throw new Error('Error al eliminar tema');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const GetConfig = async (targetScreenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/GetConfig/${targetScreenId}`);
        if (!response.ok) throw new Error('Error al obtener configuración');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const SaveConfig = async (data) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/SaveConfig`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error('Error al guardar configuración');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const UploadMedia = async (formData) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/UploadMedia`, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) throw new Error('Error al subir multimedia');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const PrepareScreen = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/PrepareScreen/${screenId}`, {
            method: 'POST'
        });
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const ProyectarScreen = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/ProyectarScreen/${screenId}`, {
            method: 'POST'
        });
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const StartGame = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/StartGame/${screenId}`, {
            method: 'POST'
        });
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const GetHistory = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/GetHistory/${screenId}`);
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const StopGame = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/StopGame/${screenId}`, {
            method: 'POST'
        });
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const ResetGame = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/ResetGame/${screenId}`, {
            method: 'POST'
        });
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const Jump = async (screenId, playerName = 'Admin') => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/Jump/${screenId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ playerName })
        });
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};
